import { AuthXInterceptor } from '../Config/AuthXInterceptor'

export const transactionBXService = {
  // Get all transactions
  index: async (params?: {
    page?: number
    limit?: number
    sortOrder?: 'ASC' | 'DESC'
    startDate?: string
    endDate?: string
    status?: string
    type?: string
    userResourceId?: string
  }) => {
    return AuthXInterceptor.get('transactions', {
      params,
    })
  },

  // Get single transaction
  show: async (transactionId: string) => {
    return AuthXInterceptor.get(`transactions/${transactionId}`)
  },

  processWithdrawal: async (payload: {
    userResourceId: string
    amountMajor: number
    note: string
  }) => {
    return AuthXInterceptor.post('transactions/process-withdrawal', payload)
  },

  exportCSV: async (params?: any) => {
    return AuthXInterceptor.get('transactions/csv', {
      params,
      responseType: 'blob',
    })
  },
}
